import React from 'react';
import "./Footer.css"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container text-center">
        <p>&copy; Vanessa Ferreira, 2023. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
